import { decimal, money, taxRate } from '@/js/shared/billables/decimal';

export function calculateRefundTotals({ items, taxRate: rate, shipping, shippingTax }) {
  const refundedItems = items.filter((item) => item.refunded);
  const subtotal = money(
    refundedItems.reduce((sum, item) => sum.plus(money(item.amount)), decimal(0))
  );
  const taxableSubtotal = refundedItems
    .filter((item) => item.taxed)
    .reduce((sum, item) => sum.plus(money(item.amount)), decimal(0));
  const tax = taxableSubtotal.times(taxRate(rate)).div('100').round(2);
  const total = subtotal
    .plus(tax)
    .plus(money(shipping || 0))
    .plus(money(shippingTax || 0))
    .round(2);

  return {
    subtotal: subtotal.toFixed(2),
    tax: tax.toFixed(2),
    total: total.toFixed(2),
  };
}
